// extracted by mini-css-extract-plugin
export var contact = "contact-module--contact--Iuov3";
export var hidden = "contact-module--hidden--Jc9oV";
export var landlord = "contact-module--landlord--9quCm";
export var link = "contact-module--link--kUItO";
export var privacy = "contact-module--privacy--9ecDC";
export var socials = "contact-module--socials--r3LQX";
export var text = "contact-module--text--aZaX1";
export var toggleWrapper = "contact-module--toggleWrapper--WcaB6";